import api from './api';

class ProductService {
    async getProducts(params = {}) {
        return api.get('products/', { params });
    }

    async getProduct(id) {
        return api.get(`products/${id}/`);
    }

    async getHomepageImages() {
        return api.get('products/homepage-images/');
    }

    async createCustomRequest(formData) {
        return api.post('products/custom-requests/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    async getCustomRequests(params = {}) {
        return api.get('products/custom-requests/', { params });
    }
}

export default new ProductService();
